var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6431 10.7571C20.6431 16.7571 12.6431 22.7571 12.6431 22.7571C12.6431 22.7571 4.64307 16.7571 4.64307 10.7571C4.64307 8.63535 5.48592 6.60052 6.98621 5.10023C8.4865 3.59993 10.5213 2.75708 12.6431 2.75708C14.7648 2.75708 16.7996 3.59993 18.2999 5.10023C19.8002 6.60052 20.6431 8.63535 20.6431 10.7571Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6431 13.7571C14.2999 13.7571 15.6431 12.4139 15.6431 10.7571C15.6431 9.10023 14.2999 7.75708 12.6431 7.75708C10.9862 7.75708 9.64307 9.10023 9.64307 10.7571C9.64307 12.4139 10.9862 13.7571 12.6431 13.7571Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.3bb1ac354925163846f9ea28f2d25d01.svg";
export { ForwardRef as ReactComponent };